import toast from "react-hot-toast";
import { log, supabase } from ".";

export const saveUsuario = async (usuario) => {
  try {
    const data = await supabase.insert("usuarios", {
      ...usuario,
      cliente_id: usuario.cliente_id !== undefined ? usuario.cliente_id : null,
    });

    if (!data || data.length === 0) {
      toast.error("No se pudo guardar el usuario");
      throw new Error("Empty response");
    }

    return data;
  } catch (error) {
    log.error("saveUsuario", error);
    toast.error("Error al guardar usuario en la base de datos");
    throw error;
  }
};
